import { apiClient } from '../Auth/apiClient';
import IPageResultDto from '../Interfaces/IPageResultDto';
import IResponseBaseDto from '../Interfaces/IResponseBaseDto';
import IResponseBaseTDto from '../Interfaces/IResponseBaseTDto';
import ISearchBaseDto from '../Interfaces/ISearchBaseDto';
import { IUserViewDto, userType, IUserDetailsDto } from '../Interfaces/IUserDtos';

export interface IUserServiceAPI {
	GetOne: (id: string) => Promise<IResponseBaseTDto<IUserDetailsDto>>;
	GetPage?: (data: ISearchBaseDto) => Promise<IResponseBaseTDto<IPageResultDto<IUserViewDto>>>;
	Update: (data: IUserDetailsDto) => Promise<IResponseBaseDto>;
	Add: (data: IUserDetailsDto, id?: string) => Promise<IResponseBaseDto>;
	Delete: (data: string) => Promise<IResponseBaseDto>;
}

export const DealerAdminServiceAPI: IUserServiceAPI = getUserServiceApi(userType.DealerAdmin);
export const CorporationAdminServiceAPI: IUserServiceAPI = getUserServiceApi(userType.CorporationAdmin);
export const LocationAdminServiceAPI: IUserServiceAPI = getUserServiceApi(userType.LocationAdmin);

function getUserServiceApi(userType: userType): IUserServiceAPI {
	return {
		GetOne: async (id: string): Promise<IResponseBaseTDto<IUserDetailsDto>> => {
			const response = await apiClient.post('user', { userId: id });
			return response.data;
		},
		GetPage: async (data: ISearchBaseDto): Promise<IResponseBaseTDto<IPageResultDto<IUserViewDto>>> => {
			const response = await apiClient.post('users', data);
			return response.data;
		},
		Update: async (data: IUserDetailsDto): Promise<IResponseBaseDto> => {
			const response = await apiClient.put(`users/${data.id}`, data);
			return response.data;
		},
		Add: async (data: IUserDetailsDto): Promise<IResponseBaseDto> => {
			const response = await apiClient.post(`users/${userType}`, data);
			return response.data;
		},
		Delete: async (data: string): Promise<IResponseBaseDto> => {
			const response = await apiClient.delete(`users/${data}`);
			return response.data;
		},
	};
}

export const CommonUserServiceAPI = {
	GetOne: async (id: string): Promise<IResponseBaseTDto<IUserDetailsDto>> => {
		const response = await apiClient.post('user', { userId: id });
		return response.data;
	},
	GetPage: async (data: ISearchBaseDto): Promise<IResponseBaseTDto<IPageResultDto<IUserViewDto>>> => {
		const response = await apiClient.post('users', data);
		return response.data;
	},
	Update: async (data: IUserDetailsDto): Promise<IResponseBaseDto> => {
		const response = await apiClient.put(`users/${data.id}`, data);
		return response.data;
	},
	Delete: async (data: string): Promise<IResponseBaseDto> => {
		const response = await apiClient.delete(`users/${data}`);
		return response.data;
	},
};